'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var tz = _interopDefault(require('moment-timezone'));

var styled = require('styled-components');

var styled__default = _interopDefault(styled);

var reactHooks = require('@apollo/react-hooks');

var ApolloClient = _interopDefault(require('apollo-boost'));

var gql = _interopDefault(require('graphql-tag'));

var _ = _interopDefault(require('lodash'));

var moment = _interopDefault(require('moment'));

var OutsideClickHandler = _interopDefault(require('react-outside-click-handler'));

var Masked = _interopDefault(require('react-maskedinput'));

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var taggedTemplateLiteral = _taggedTemplateLiteral;

var client = function client(uri) {
  return new ApolloClient({
    uri: uri
  });
};

var config = {
  developmentGraphqlUri: "https://spacex-db2-staging.herokuapp.com/graphql",
  productionGraphqlUri: "https://srv-contactsmarter.herokuapp.com/graphql"
};
var TimezoneContext = React__default.createContext({
  timezone: tz.tz.guess(),
  setTimezone: function setTimezone() {}
});

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports);

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});
var regenerator = runtime_1;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;
var ICONS = {
  LEFT_ARROW: {
    paths: ["M703.305 962.878c6.35 6.35 14.288 9.526 23.020 9.526s16.67-3.175 23.020-9.526c12.701-12.701 12.701-33.34 0-46.040l-404.837-404.837 404.837-404.837c12.701-12.701 12.701-33.34 0-46.040s-33.34-12.701-46.040 0l-428.651 427.857c-12.701 12.701-12.701 33.34 0 46.040l428.651 427.857z"]
  },
  RIGHT_ARROW: {
    paths: ["M320.695 962.878c-6.35 6.35-14.288 9.526-23.020 9.526s-16.67-3.175-23.020-9.526c-12.701-12.701-12.701-33.34 0-46.040l404.837-404.837-404.837-404.837c-12.701-12.701-12.701-33.34 0-46.040s33.34-12.701 46.040 0l427.857 427.857c12.701 12.701 12.701 33.34 0 46.040l-427.857 427.857z"]
  },
  CROSS: {
    paths: ["M602.561 512.011l402.675-402.675c25.018-24.996 25.018-65.554 0-90.551-25.018-25.018-65.533-25.018-90.551 0l-402.675 402.675-402.697-402.675c-25.018-25.018-65.533-25.018-90.551 0-25.018 24.996-25.018 65.554 0 90.551l402.697 402.675-402.697 402.675c-25.018 24.996-25.018 65.554 0 90.551 12.509 12.488 28.903 18.742 45.275 18.742s32.766-6.254 45.275-18.763l402.697-402.675 402.675 402.675c12.509 12.509 28.903 18.763 45.275 18.763s32.766-6.254 45.275-18.763c25.018-24.996 25.018-65.554 0-90.551l-402.675-402.654z"]
  },
  SUCCESS: {
    paths: ["M512 0c-282.309 0-512 229.671-512 512s229.691 512 512 512 512-229.671 512-512-229.691-512-512-512zM797.44 341.248l-315.077 354.462c-7.759 8.724-18.57 13.214-29.46 13.214-8.645 0-17.329-2.836-24.596-8.625l-196.923-157.538c-16.975-13.568-19.732-38.361-6.144-55.355 13.568-16.994 38.38-19.751 55.355-6.164l167.719 134.164 290.245-326.518c14.415-16.266 39.345-17.723 55.591-3.269 16.266 14.474 17.743 39.365 3.289 55.631z"]
  }
};

function Icon(_ref) {
  var style = _ref.style,
      color = _ref.color,
      size = _ref.size,
      icon = _ref.icon,
      width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      transform = _ref.transform,
      onClick = _ref.onClick;
  return React__default.createElement("svg", {
    width: "".concat(width || size, "px"),
    height: "".concat(height || size, "px"),
    transform: transform,
    viewBox: viewBox || "0 0 1024 1024",
    style: style,
    onClick: onClick
  }, ICONS[icon].paths.map(function (path, i) {
    return React__default.createElement("path", {
      key: i // eslint-disable-line
      ,
      style: {
        fill: color,
        transitionDuration: "0.4s"
      },
      d: path
    });
  }));
}

Icon.defaultProps = {
  size: 20,
  color: "#999999"
};

function _templateObject8() {
  var data = taggedTemplateLiteral(["\n        padding: 8px 0;\n        width: 100%;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-auto-rows: 40px;\n  grid-gap: 16px;\n  margin: 0 32px;\n  justify-items: center;\n  align-items: center;\n\n  @media (max-width: 554px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  div {\n    padding: 8px 32px;\n    border-radius: 16px;\n    background-color: #e9eff5;\n    color: ", ";\n    text-align: center;\n    cursor: pointer;\n\n    :hover {\n      background-color: #d8e5f5;\n    }\n\n    ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-template-rows: 40px repeat(6, 48px);\n  grid-auto-rows: 48px;\n  grid-gap: 12px 4px;\n  max-width: 100%;\n  font-weight: 500;\n\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    user-select: none;\n  }\n\n  @media (max-width: 554px) {\n    grid-template-rows: 40px repeat(6, 28px);\n    grid-auto-rows: 28px;\n  }\n\n  ", " {\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = taggedTemplateLiteral(["\n        padding: 2px;\n        border: ", ";\n        transition: background-color 200ms ease-in;\n        background-color: rgba(108, 149, 188, 0.15);\n        color: ", ";\n\n        :hover {\n          background-color: #d8e5f5;\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  div {\n    height: 48px;\n    width: 48px;\n    border-radius: 50%;\n    color: ", ";\n    border: ", ";\n    cursor: pointer;\n\n    ", ";\n\n    @media (max-width: 554px) {\n      height: 28px;\n      width: 28px;\n      font-weight: 400;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = taggedTemplateLiteral(["\n  font-size: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: minmax(64px, auto) 1fr minmax(64px, auto);\n  justify-items: center;\n  align-items: center;\n  margin-bottom: 24px;\n  width: 100%;\n\n  .on-action {\n    cursor: pointer;\n  }\n\n  span {\n    cursor: pointer;\n    user-select: none;\n    color: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    text-align: center;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled__default.div(_templateObject());
var Navigation = styled__default.div(_templateObject2(), function (props) {
  return props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(16);
});
var WeekDay = styled__default.div(_templateObject3(), function (props) {
  return props.theme.unit.getRem(12);
});
var CalendarDay = styled__default.div(_templateObject4(), function (props) {
  return props.theme.color.textGray;
}, function (props) {
  return props.isToday ? "solid 2px rgba(0, 0, 0, 0.2)" : "0";
}, function (props) {
  return props.available && styled.css(_templateObject5(), function (props) {
    return props.isToday ? "solid 2px ".concat(props.theme.color.textBlue) : "0";
  }, function (props) {
    return props.theme.color.textBlue;
  });
});
var CalendarGrid = styled__default.div(_templateObject6(), WeekDay, function (props) {
  return props.theme.color.textDarkGray;
});
var DateGrid = styled__default.div(_templateObject7(), function (props) {
  return props.theme.color.textBlue;
}, function (props) {
  return props.fullWidth && styled.css(_templateObject8());
});

var Calendar = function Calendar(_ref) {
  var setDate = _ref.setDate,
      props = objectWithoutProperties(_ref, ["setDate"]);

  var _useState = React.useState(true),
      _useState2 = slicedToArray(_useState, 2),
      showCalendarGrid = _useState2[0],
      setShowCalendarGrid = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      showMonthGrid = _useState4[0],
      setShowMonthGrid = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      showYearGrid = _useState6[0],
      setShowYearGrid = _useState6[1];

  var _useState7 = React.useState(moment()),
      _useState8 = slicedToArray(_useState7, 2),
      dateObj = _useState8[0],
      setDateObj = _useState8[1];

  var handleDate = function handleDate() {
    props.editYear && setShowYearGrid(true);
    props.editMonth && setShowMonthGrid(true);
    (props.editYear || props.editMonth) && setShowCalendarGrid(false);
  };

  var setDay = function setDay(day) {
    var newDateObj = moment(dateObj).set("date", day);
    setDateObj(newDateObj);
    setDate && setDate(newDateObj.format("YYYY-MM-DD"));
  };

  var setMonth = function setMonth(month) {
    var monthNo = moment.months().indexOf(month);
    var newDateObj = moment(dateObj).set("month", monthNo);
    setDateObj(newDateObj);
    setShowMonthGrid(false);
    setShowCalendarGrid(true);
  };

  var setYear = function setYear(year) {
    var newDateObj = moment(dateObj).set("year", year);
    setDateObj(newDateObj);
    setShowMonthGrid(true);
    setShowYearGrid(false);
  };

  var YearGrid = function YearGrid() {
    var currentYear = dateObj.format("Y");
    var nextTwelveYears = [];

    var _loop = function _loop(i) {
      nextTwelveYears.push(React__default.createElement("div", {
        key: i,
        onClick: function onClick() {
          return setYear(i);
        }
      }, i));
    };

    for (var i = Number(currentYear); i <= Number(currentYear) + 11; i++) {
      _loop(i);
    }

    return React__default.createElement(DateGrid, null, nextTwelveYears);
  };

  var MonthGrid = function MonthGrid() {
    var getMonths = moment.months();
    return React__default.createElement(DateGrid, {
      fullWidth: true
    }, getMonths.map(function (month) {
      return React__default.createElement("div", {
        key: month,
        onClick: function onClick() {
          return setMonth(month);
        }
      }, month);
    }));
  };

  var onPrev = function onPrev() {
    var current = showMonthGrid ? "year" : "month";
    var newDateObj = moment(dateObj);
    setDateObj(newDateObj.subtract(1, current));
  };

  var onNext = function onNext() {
    var current = showMonthGrid ? "year" : "month";
    var newDateObj = moment(dateObj);
    setDateObj(newDateObj.add(1, current));
  };

  var firstDayOfMonth = function firstDayOfMonth() {
    return moment(dateObj).startOf("month").format("d");
  };

  var blanks = [];

  for (var i = 0; i < firstDayOfMonth(); i++) {
    blanks.push(React__default.createElement("div", {
      key: "blank_".concat(i)
    }, ""));
  }

  var daysInMonthArr = [];
  var newDateObj = moment(dateObj);

  var _loop2 = function _loop2(day) {
    var currentday = newDateObj.set("date", day).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");
    var available = props.availables.find(function (slot) {
      return moment(slot).format("YYYY-MM-DD") === newDateObj.set("date", day).format("YYYY-MM-DD");
    });
    daysInMonthArr.push(React__default.createElement(CalendarDay, {
      key: day,
      isToday: currentday,
      available: available,
      onClick: function onClick() {
        available && setDay(day);
      }
    }, React__default.createElement("div", null, day)));
  };

  for (var day = 1; day <= dateObj.daysInMonth(); day++) {
    _loop2(day);
  }

  var weekDaysShortNames = moment.weekdaysShort();
  var totalSlots = [].concat(blanks, daysInMonthArr);
  return React__default.createElement(Container, null, React__default.createElement(Navigation, null, React__default.createElement("div", {
    className: "on-action",
    onClick: onPrev
  }, React__default.createElement(Icon, {
    icon: "LEFT_ARROW",
    color: "#6c95bc",
    size: 16
  })), React__default.createElement("span", {
    onClick: handleDate
  }, dateObj.format("MMMM YYYY")), React__default.createElement("div", {
    className: "on-action",
    onClick: onNext
  }, React__default.createElement(Icon, {
    icon: "RIGHT_ARROW",
    color: "#6c95bc",
    size: 16
  }))), showYearGrid && React__default.createElement(YearGrid, null), showMonthGrid && React__default.createElement(MonthGrid, null), showCalendarGrid && React__default.createElement(CalendarGrid, null, weekDaysShortNames.map(function (day) {
    return React__default.createElement(WeekDay, {
      key: day
    }, day);
  }), totalSlots));
};

var Calendar$1 = styled.withTheme(Calendar);

function _templateObject6$1() {
  var data = taggedTemplateLiteral(["\n  font-size: ", ";\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  cursor: pointer;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 1.5;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 1.5;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 1.5;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 40px;\n  width: 100%;\n  text-align: center;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Header = styled__default.div(_templateObject$1());
var Title = styled__default.span(_templateObject2$1(), function (props) {
  return props.theme.color.textBlack;
}, function (props) {
  return props.theme.unit.getRem(22);
});
var Heading = styled__default.span(_templateObject3$1(), function (props) {
  return props.theme.color.textBlack;
}, function (props) {
  return props.theme.unit.getRem(18);
});
var Subtitle = styled__default.span(_templateObject4$1(), function (props) {
  return props.theme.unit.getRem(16);
});
var Action = styled__default.span(_templateObject5$1(), function (props) {
  return props.theme.color.textBlue;
}, function (props) {
  return props.theme.unit.getRem(12);
});
var Label = styled__default.span(_templateObject6$1(), function (props) {
  return props.theme.unit.getRem(12);
});

function _templateObject2$2() {
  var data = taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  width: 48px;\n  height: 48px;\n\n  div {\n    display: block;\n    position: absolute;\n    margin: 8px;\n    height: 32px;\n    width: 32px;\n    border: 4px solid #7098be;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border-color: #7098be transparent transparent transparent;\n    animation: ", " 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  }\n\n  div:nth-child(1) {\n    animation-delay: -0.45s;\n  }\n\n  div:nth-child(2) {\n    animation-delay: -0.3s;\n  }\n\n  div:nth-child(3) {\n    animation-delay: -0.15s;\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var rotate = styled.keyframes(_templateObject$2());
var Spinner = styled__default.div(_templateObject2$2(), rotate);

var Loading = function Loading() {
  return React__default.createElement(Spinner, null, React__default.createElement("div", null), React__default.createElement("div", null), React__default.createElement("div", null), React__default.createElement("div", null));
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var SelectDate = function SelectDate(_ref) {
  var data = _ref.data,
      props = objectWithoutProperties(_ref, ["data"]);

  var setDate = function setDate(date) {
    props.setAppointment(_objectSpread({}, props.appointment, {
      date: date
    }));
    if (window && window.analytics) window.analytics.track("AppointmentDate Selected", {
      date: date
    });
    props.handleStep("SELECT_TIME");
  };

  var slots = _.get(data, "slots", "{}");

  if (typeof slots === "string") slots = JSON.parse(slots);
  var availables = Object.keys(slots);
  if (_.isEmpty(data)) return React__default.createElement(Loading, null);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Header, null, React__default.createElement(Title, {
    style: {
      marginBottom: 8
    }
  }, data.title || "..."), React__default.createElement(Subtitle, {
    style: {
      marginBottom: 16
    }
  }, data.description || "..."), React__default.createElement(Label, null, "With ", data.fullName || "...")), React__default.createElement(Calendar$1, {
    editMonth: true,
    availables: availables,
    setDate: setDate
  }));
};

function useInterval(callback, delay) {
  var savedCallback = React.useRef(); // Remember the latest function.

  React.useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  React.useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

function _templateObject7$1() {
  var data = taggedTemplateLiteral(["\n  overflow-y: auto;\n  max-height: 352px;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = taggedTemplateLiteral(["\n        width: 100%;\n        padding: 8px 0;\n      "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = taggedTemplateLiteral(["\n  font-size: ", ";\n  display: grid;\n  justify-items: center;\n  align-items: center;\n  grid-template-columns: repeat(3, 1fr);\n  grid-auto-rows: 40px;\n  grid-gap: 16px;\n  margin: 24px;\n\n  @media (max-width: 554px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  div {\n    background-color: #e9eff5;\n    color: ", ";\n    text-align: center;\n    border-radius: 16px;\n    padding: 8px 24px;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 200ms ease-in;\n\n    :hover {\n      background-color: #d8e5f5;\n    }\n\n    ", ";\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = taggedTemplateLiteral([""]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = taggedTemplateLiteral(["\n  text-align: center;\n  margin: 24px 0;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$1 = styled__default.div(_templateObject$3());
var Time = styled__default.div(_templateObject2$3());
var Grid = styled__default.div(_templateObject3$2(), function (props) {
  return props.theme.unit.getRem(14);
}, function (props) {
  return props.theme.color.textBlue;
}, function (props) {
  return props.fullWidth && styled.css(_templateObject4$2());
});
var Greeting = styled__default.span(_templateObject5$2(), function (props) {
  return props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(16);
});
var NotAvailable = styled__default.span(_templateObject6$2(), function (props) {
  return props.theme.color.textGray;
}, function (props) {
  return props.theme.unit.getRem(14);
});
var TimesContainer = styled__default.div(_templateObject7$1());

var getGreetingTime = function getGreetingTime(m) {
  if (!m || !m.isValid()) return;
  var g = null;
  var splitAfternoon = 12;
  var splitEvening = 17;
  var currentHour = parseFloat(m.format("HH"));

  if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
    g = "AFTERNOON";
  } else if (currentHour > splitEvening) {
    g = "EVENING";
  } else {
    g = "MORNING";
  }

  return g;
};

var SelectTime = function SelectTime(props) {
  var times = {
    morning: [],
    afternoon: [],
    evening: []
  };
  props.times.forEach(function (time) {
    var startAt = moment("".concat(props.date, " ").concat(time.startAt));
    var endAt = moment("".concat(props.date, " ").concat(time.endAt));
    var greetingTime = getGreetingTime(startAt);
    if (greetingTime === "MORNING") times.morning.push({
      startAt: startAt,
      endAt: endAt
    });
    if (greetingTime === "AFTERNOON") times.afternoon.push({
      startAt: startAt,
      endAt: endAt
    });
    if (greetingTime === "EVENING") times.evening.push({
      startAt: startAt,
      endAt: endAt
    });
  });

  var renderTimes = function renderTimes(key) {
    var hours = times[key];
    if (_.isEmpty(hours)) return null;
    return React__default.createElement(Time, null, React__default.createElement(Greeting, null, _.capitalize(key)), React__default.createElement(Grid, null, hours.map(function (date, index) {
      return React__default.createElement("div", {
        onClick: function onClick() {
          return props.setTime({
            startAt: date.startAt.format("HH:mm"),
            endAt: date.endAt.format("HH:mm")
          });
        },
        key: "".concat(key, "_").concat(index)
      }, date.startAt.format("hh:mm A"));
    })));
  };

  var morning = times.morning,
      afternoon = times.afternoon,
      evening = times.evening;
  return React__default.createElement(Container$1, null, _.isEmpty(morning) && _.isEmpty(afternoon) && _.isEmpty(evening) && React__default.createElement(NotAvailable, null, "There are no availabilities to show."), React__default.createElement(TimesContainer, null, renderTimes("morning"), renderTimes("afternoon"), renderTimes("evening")));
};

function _templateObject6$3() {
  var data = taggedTemplateLiteral(["\n      cursor: pointer;\n    "]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 32px;\n  width: 100%;\n  box-sizing: border-box;\n  user-select: none;\n\n  @media (max-width: 554px) {\n    padding: 8px 16px;\n  }\n\n  :hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", ";\n\n  .time {\n    text-align: right;\n\n    @media (max-width: 554px) {\n      display: none;\n    }\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = taggedTemplateLiteral(["\n  height: 296px;\n  max-width: 100%;\n  overflow: auto;\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = taggedTemplateLiteral(["\n  padding: 8px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  color: ", ";\n  font-size: ", ";\n\n  :focus {\n    outline: none;\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  min-height: 448px;\n  min-width: 480px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border-radius: 10px;\n  background-color: #ffffff;\n  color: ", ";\n\n  @media (max-width: 554px) {\n    width: auto;\n    min-height: auto;\n    max-width: 480px;\n    min-width: 264px;\n  }\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 16px;\n\n    ", " {\n      font-weight: 600;\n      flex: 1;\n    }\n\n    .close {\n      cursor: pointer;\n      max-height: 16px;\n    }\n  }\n\n  .search {\n    display: flex;\n    flex-direction: column;\n    padding: 32px 32px 16px 32px;\n\n    @media (max-width: 554px) {\n      padding: 16px;\n    }\n  }\n\n  .location {\n    padding: 8px 32px;\n    color: ", ";\n    font-size: ", ";\n    font-weight: 600;\n    text-transform: uppercase;\n\n    @media (max-width: 554px) {\n      padding: 8px 16px;\n    }\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = taggedTemplateLiteral(["\n  display: ", ";\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  height: 100vh;\n  width: 100vw;\n  overflow-y: hidden;\n  background-color: rgba(21, 28, 38, 0.9);\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Modal = styled__default.div(_templateObject$4(), function (props) {
  return props.isOpen ? "flex" : "none";
});
var Container$2 = styled__default.div(_templateObject2$4(), function (props) {
  return props.theme.color.textBlack;
}, Subtitle, function (props) {
  return props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(14);
});
var Input = styled__default.input(_templateObject3$3(), function (props) {
  return props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(14);
});
var Select = styled__default.div(_templateObject4$3());
var Option = styled__default.div(_templateObject5$3(), function (props) {
  return props.isSelected ? "#759bc0" : "#ffffff";
}, function (props) {
  return props.isSelected ? "#fff" : props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(14);
}, function (props) {
  return props.isSelected ? "#759bc0" : "#e9eff5";
}, function (props) {
  return props.isSelected ? "#ffffff" : props.theme.color.textDarkGray;
}, function (props) {
  return !props.isSelected && styled.css(_templateObject6$3());
});

var SetTimezone = function SetTimezone(props) {
  var _useState = React.useState(""),
      _useState2 = slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var zones = _.sortBy(tz.tz.names());

  var setTimezone = function setTimezone(timezone) {
    props.setTimezone(timezone);
    props.onRequestClose();
  };

  return React__default.createElement(Modal, {
    isOpen: props.isOpen
  }, React__default.createElement(OutsideClickHandler, {
    onOutsideClick: props.onRequestClose
  }, React__default.createElement(Container$2, null, React__default.createElement("div", {
    className: "search"
  }, React__default.createElement("div", {
    className: "header"
  }, React__default.createElement(Subtitle, null, "Choose a time zone"), React__default.createElement("div", {
    className: "close",
    onClick: props.onRequestClose
  }, React__default.createElement(Icon, {
    size: 16,
    color: "#6c95bc",
    icon: "CROSS"
  }))), React__default.createElement(Input, {
    onChange: function onChange(_ref) {
      var target = _ref.target;
      return setSearchTerm(target.value);
    },
    placeholder: "Search..."
  })), React__default.createElement("div", {
    className: "location"
  }, "TIME ZONE"), React__default.createElement(Select, null, zones.filter(function (timezone) {
    return timezone.toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0;
  }).map(function (timezone) {
    return React__default.createElement(Option, {
      key: "tz_".concat(timezone),
      isSelected: props.timezone === timezone,
      onClick: function onClick() {
        return setTimezone(timezone);
      }
    }, React__default.createElement("span", null, timezone), React__default.createElement("span", {
      className: "time"
    }, tz.tz(props.utcNow, timezone).format("hh:mm A")));
  })))));
};

var SetTimezone$1 = styled.withTheme(SetTimezone);

function _templateObject3$4() {
  var data = taggedTemplateLiteral(["\n  flex: 1;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  height: 20px;\n  width: auto;\n  cursor: pointer;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin-bottom: 8px;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$3 = styled__default.div(_templateObject$5());
var Back = styled__default.div(_templateObject2$5());
var Children = styled__default.div(_templateObject3$4());

var WithBack = function WithBack(props) {
  return React__default.createElement(Container$3, null, React__default.createElement(Back, {
    onClick: props.onBack
  }, React__default.createElement(Icon, {
    icon: "LEFT_ARROW",
    size: 20
  })), React__default.createElement(Children, null, props.children));
};

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject$6() {
  var data = taggedTemplateLiteral(["\n  display: block;\n  margin: 16px 0;\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var ErrorText = styled__default.span(_templateObject$6(), function (props) {
  return props.theme.color.textRed;
});

var SelectTime$1 = function SelectTime$1(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      props = objectWithoutProperties(_ref, ["data"]);

  var _useContext = React.useContext(TimezoneContext),
      timezone = _useContext.timezone,
      setTimezone = _useContext.setTimezone;

  var _useState = React.useState(moment().utc().format()),
      _useState2 = slicedToArray(_useState, 2),
      utcNow = _useState2[0],
      setUtcNow = _useState2[1];

  React.useEffect(function () {
    if (props.appointment.time) {
      if (props.withLeadForm) {
        props.handleStep("FILL_LEAD_FORM");
      } else {
        props.confirmAppointment();
      }
    }
  }, [props.appointment]);
  useInterval(function () {
    setUtcNow(moment().utc().format());
  }, 1000);

  var setTime = function setTime(time) {
    props.setAppointment(_objectSpread$1({}, props.appointment, {
      time: time,
      timezone: timezone
    }));
    if (window && window.analytics) window.analytics.track("AppointmentSlot Selected", {
      time: time,
      timezone: timezone
    });
  };

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var slots = _.get(data, "slots", "{}");

  if (typeof slots === "string") slots = JSON.parse(slots);
  var selectedDay = props.appointment.date;
  var times = slots[selectedDay];
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(SetTimezone$1, {
    isOpen: isOpen,
    onRequestClose: function onRequestClose() {
      return setIsOpen(false);
    },
    setTimezone: setTimezone,
    timezone: timezone,
    utcNow: utcNow
  }), React__default.createElement(Header, {
    style: {
      marginBottom: 16
    }
  }, React__default.createElement(WithBack, {
    style: {
      marginBottom: 4
    },
    onBack: function onBack() {
      return props.handleStep("SELECT_DATE");
    }
  }, React__default.createElement(Subtitle, {
    style: {
      fontWeight: 600
    }
  }, moment(selectedDay).format("dddd"))), React__default.createElement(Subtitle, {
    style: {
      fontWeight: 600,
      fontSize: 18,
      marginBottom: 16
    }
  }, moment(selectedDay).format("MMMM DD, YYYY")), React__default.createElement(Action, {
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, timezone, " (", tz.tz(utcNow, timezone).format("hh:mm A"), ")")), React__default.createElement(SelectTime, {
    date: selectedDay,
    times: times || [],
    timezone: timezone,
    setTime: setTime
  }), props.error && React__default.createElement(ErrorText, null, props.error.message));
}; // eslint-disable-next-line no-useless-escape


var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-next-line no-useless-escape

var PHONE_REGEX = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

var PhoneNumberValidator = function PhoneNumberValidator(value) {
  if (!PHONE_REGEX.test(value)) {
    return "Must enter a valid phone number";
  }
};

var EmailValidator = function EmailValidator(value) {
  if (!EMAIL_REGEX.test(value)) {
    return "Must enter a valid email address";
  }
};

var NotEmptyValidator = function NotEmptyValidator(value) {
  if (!value) {
    return "This field is required.";
  }
};

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var handleInputsReadyToSend = function handleInputsReadyToSend(validated, name, isReady) {
  var inputs = Array.from(document.getElementsByClassName("wawawa-field"));
  var obj = {};
  inputs.forEach(function (input) {
    obj[input.name] = null;
  });
  return _objectSpread$2({}, obj, {}, validated, defineProperty({}, name, isReady));
};

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

function _templateObject6$4() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n  width: 100%;\n\n  ", " {\n    border: solid 1px\n      ", ";\n  }\n\n  ", " {\n    border: solid 1px\n      ", ";\n  }\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = taggedTemplateLiteral(["\n  padding: 8px;\n  border-radius: 5px;\n  color: ", ";\n  font-size: ", ";\n\n  :focus {\n    outline: none;\n  }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = taggedTemplateLiteral(["\n  margin-top: 8px;\n  color: #ea2c5a;\n  font-size: ", ";\n  font-weight: 600;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n\n  ::after {\n    color: #ea2c5a;\n    content: \" *\";\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var Label$1 = styled__default.span(_templateObject$7(), function (props) {
  return props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(14);
});
var Error$1 = styled__default.span(_templateObject2$6(), function (props) {
  return props.theme.unit.getRem(14);
});
var inputCSS = styled.css(_templateObject3$5(), function (props) {
  return props.theme.color.textDarkGray;
}, function (props) {
  return props.theme.unit.getRem(14);
});
var Input$1 = styled__default.input(_templateObject4$4(), inputCSS);
var MaskedInput = styled__default(Masked)(_templateObject5$4(), inputCSS);
var InputGroup = styled__default.div(_templateObject6$4(), Input$1, function (props) {
  return props.isValid ? "rgba(0, 0, 0, 0.2)" : "#ea2c5a";
}, MaskedInput, function (props) {
  return props.isValid ? "rgba(0, 0, 0, 0.2)" : "#ea2c5a";
});

var Wrapper = function Wrapper(_ref) {
  var setReadyToSend = _ref.setReadyToSend,
      props = objectWithoutProperties(_ref, ["setReadyToSend"]);

  var _useState = React.useState(null),
      _useState2 = slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var validate = function validate(value) {
    var withError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var getErr;

    if (Array.isArray(props.validate)) {
      getErr = props.validate.map(function (validation) {
        return validation(value);
      });
    } else {
      getErr = [props.validate(value)];
    }

    var errorMessage = getErr.find(function (err) {
      return typeof err !== "undefined";
    });

    if (value !== null && errorMessage) {
      if (withError) setError({
        message: errorMessage
      });
      setReadyToSend(props.name, false);
    } else {
      setError(null);
      setReadyToSend(props.name, true);
    }
  };

  var input = React__default.createElement(Input$1, _extends_1({}, props, {
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      props.onChange(target.value);
      validate(target.value, false);
    },
    onFocus: function onFocus() {
      return setError(null);
    },
    onBlur: function onBlur(_ref3) {
      var target = _ref3.target;
      return validate(target.value);
    },
    className: "wawawa-field"
  }));

  if (props.mask) {
    input = React__default.createElement(MaskedInput, _extends_1({}, props, {
      onChange: function onChange(_ref4) {
        var target = _ref4.target;
        props.onChange(target.value);
        validate(target.value, false);
      },
      onFocus: function onFocus() {
        return setError(null);
      },
      onBlur: function onBlur(_ref5) {
        var target = _ref5.target;
        return validate(target.value);
      },
      className: "wawawa-field"
    }));
  }

  return React__default.createElement(InputGroup, {
    isValid: !error
  }, React__default.createElement(Label$1, null, props.label), input, error && React__default.createElement(Error$1, null, error.message));
};

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject4$5() {
  var data = taggedTemplateLiteral(["\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px 0;\n  padding: 8px 0;\n  width: 100%;\n  border-radius: 5px;\n  background-color: ", ";\n  color: #ffffff;\n  font-size: ", ";\n  font-weight: 600;\n  cursor: pointer;\n\n  @media (max-width: 554px) {\n    margin: 8px 0;\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: column;\n  grid-column-gap: 16px;\n\n  @media (max-width: 554px) {\n    grid-auto-flow: row;\n    grid-column-gap: 0;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$4 = styled__default.div(_templateObject$8());
var Row = styled__default.div(_templateObject2$7());
var Button = styled__default.div(_templateObject3$6(), function (props) {
  return !props.disabled ? "#769cc0" : "rgba(118, 156, 192, 0.7)";
}, function (props) {
  return props.theme.unit.getRem(16);
});
var ErrorText$1 = styled__default.span(_templateObject4$5(), function (props) {
  return props.theme.color.textRed;
});

var LeadForm = function LeadForm(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      appointment = _ref.appointment,
      props = objectWithoutProperties(_ref, ["data", "appointment"]);

  var _useState = React.useState(_.get(appointment, "prospect", {})),
      _useState2 = slicedToArray(_useState, 2),
      prospect = _useState2[0],
      setProspect = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      readyToSend = _useState4[0],
      setReadyToSend = _useState4[1];

  var _useState5 = React.useState({}),
      _useState6 = slicedToArray(_useState5, 2),
      validatedInputs = _useState6[0],
      setValidatedInputs = _useState6[1];

  var meetDateStartAt = moment("".concat(appointment.date, " ").concat(appointment.time.startAt));
  var meetDateEndAt = moment("".concat(appointment.date, " ").concat(appointment.time.endAt));
  var formatedTimezone = tz.tz(appointment.timezone).format("z");

  var handleReadyToSend = function handleReadyToSend(name, isReady) {
    var nextValidatedInputs = handleInputsReadyToSend(validatedInputs, name, isReady);
    var readyToSend = Object.keys(nextValidatedInputs).every(function (name) {
      return Boolean(nextValidatedInputs[name]);
    });
    setReadyToSend(readyToSend);
    setValidatedInputs(nextValidatedInputs);
  };

  var handleProspect = function handleProspect(prospect) {
    setProspect(prospect);
    props.setAppointment(_objectSpread$3({}, appointment, {
      prospect: prospect
    }));
  };

  var goBack = function goBack() {
    props.setAppointment(_objectSpread$3({}, appointment, {
      time: null
    }));
    props.handleStep("SELECT_TIME");
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Header, {
    style: {
      marginBottom: 40
    }
  }, React__default.createElement(WithBack, {
    style: {
      marginBottom: 16
    },
    onBack: goBack
  }, React__default.createElement(Subtitle, {
    style: {
      fontWeight: 600
    }
  }, data.title || "...")), React__default.createElement(Subtitle, {
    style: {
      fontWeight: 600,
      fontSize: 18,
      marginBottom: 4
    }
  }, moment(appointment.date).format("ddd, MMMM DD, YYYY")), React__default.createElement(Subtitle, {
    style: {
      fontWeight: 600,
      fontSize: 18
    }
  }, meetDateStartAt.format("hh:mm A"), " -", " ", meetDateEndAt.format("hh:mm A"), React__default.createElement(Action, {
    style: {
      fontSize: 18
    }
  }, " (", formatedTimezone, ")")), React__default.createElement(Label, {
    style: {
      marginTop: 8
    }
  }, "With ", data.fullName)), React__default.createElement(Container$4, null, React__default.createElement(Row, null, React__default.createElement(Wrapper, {
    name: "firstName",
    label: "First name",
    defaultValue: prospect.firstName,
    validate: NotEmptyValidator,
    onChange: function onChange(firstName) {
      return handleProspect(_objectSpread$3({}, prospect, {
        firstName: firstName
      }));
    },
    setReadyToSend: handleReadyToSend
  }), React__default.createElement(Wrapper, {
    name: "lastName",
    label: "Last name",
    defaultValue: prospect.lastName,
    validate: NotEmptyValidator,
    onChange: function onChange(lastName) {
      return handleProspect(_objectSpread$3({}, prospect, {
        lastName: lastName
      }));
    },
    setReadyToSend: handleReadyToSend
  })), React__default.createElement(Wrapper, {
    name: "phone",
    label: "Phone number",
    defaultValue: prospect.phone,
    mask: "(111) 111-1111",
    validate: [NotEmptyValidator, PhoneNumberValidator],
    onChange: function onChange(phone) {
      return handleProspect(_objectSpread$3({}, prospect, {
        phone: phone
      }));
    },
    setReadyToSend: handleReadyToSend
  }), React__default.createElement(Wrapper, {
    name: "email",
    label: "Email",
    defaultValue: prospect.email,
    validate: [NotEmptyValidator, EmailValidator],
    onChange: function onChange(email) {
      return handleProspect(_objectSpread$3({}, prospect, {
        email: email
      }));
    },
    setReadyToSend: handleReadyToSend
  }), React__default.createElement(Button, {
    disabled: !readyToSend,
    onClick: function onClick() {
      return readyToSend && props.confirmAppointment();
    }
  }, "Schedule appointment"), props.error && React__default.createElement(ErrorText$1, null, props.error.message)));
};

var LeadForm$1 = styled.withTheme(LeadForm);

function _templateObject$9() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  text-align: center;\n\n  .icon {\n    height: 64px;\n    width: 64px;\n  }\n\n  .info-title {\n    margin: 24px 0 16px 0;\n  }\n\n  .appointment-info {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 40px;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$5 = styled__default.div(_templateObject$9());

var Confirmation = function Confirmation(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      appointment = _ref.appointment,
      props = objectWithoutProperties(_ref, ["data", "appointment"]);
  var meetDateStartAt = moment("".concat(appointment.date, " ").concat(appointment.time.startAt));
  var meetDateEndAt = moment("".concat(appointment.date, " ").concat(appointment.time.endAt));
  var formatedTimezone = tz.tz(appointment.timezone).format("z");
  return React__default.createElement(Container$5, null, React__default.createElement(Icon, {
    size: 64,
    color: "#97DE95",
    icon: "SUCCESS"
  }), React__default.createElement(Title, {
    style: {
      margin: "16px 0px"
    }
  }, "Confirmed!"), React__default.createElement("div", {
    className: "info-title"
  }, React__default.createElement(Subtitle, null, "Your appointment is scheduled for:")), React__default.createElement("div", {
    className: "appointment-info"
  }, React__default.createElement(Heading, {
    style: {
      marginBottom: 4
    }
  }, moment(appointment.date).format("ddd, MMMM DD, YYYY")), React__default.createElement(Heading, {
    style: {
      marginBottom: 8
    }
  }, meetDateStartAt.format("hh:mm A"), " -", " ", meetDateEndAt.format("hh:mm A"), " (", formatedTimezone, ")"), React__default.createElement(Label, null, "With ", data.fullName)), React__default.createElement("div", null, React__default.createElement(Heading, {
    style: {
      fontSize: 18
    }
  }, "A calendar invitation has been sent to your email address.")));
};

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject3$7() {
  var data = taggedTemplateLiteral(["\n  mutation(\n    $campaignUid: String!\n    $prospect: ProspectInputType!\n    $timezone: String!\n    $time: String!\n  ) {\n    bookAppointment(\n      campaignUid: $campaignUid\n      prospect: $prospect\n      timezone: $timezone\n      time: $time\n    ) {\n      ok\n      errorMessage\n    }\n  }\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = taggedTemplateLiteral(["\n  query($campaignUid: String!) {\n    getCalendar(campaignUid: $campaignUid) {\n      title\n      fullName\n      description\n      slots\n      facebookPixelId\n    }\n  }\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n  max-height: 90vh;\n  min-height: 556px;\n  min-width: 264px;\n  width: 480px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border-radius: 10px;\n  background-color: #ffffff;\n  color: ", ";\n\n  @media (max-width: 554px) {\n    padding: 16px;\n    min-height: auto;\n    width: auto;\n  }\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var Container$6 = styled__default.div(_templateObject$a(), function (props) {
  return props.theme.color.textBlack;
});
var GET_CALENDAR = gql(_templateObject2$8());
var BOOK_APPOINTMENT = gql(_templateObject3$7());

var Appointment = function Appointment(props) {
  var _useState = React.useState({}),
      _useState2 = slicedToArray(_useState, 2),
      appointment = _useState2[0],
      setAppointment = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      confirmed = _useState6[0],
      setConfirmation = _useState6[1];

  var _useState7 = React.useState("SELECT_DATE"),
      _useState8 = slicedToArray(_useState7, 2),
      currentStep = _useState8[0],
      handleStep = _useState8[1];

  var _useState9 = React.useState(null),
      _useState10 = slicedToArray(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var _useMutation = reactHooks.useMutation(BOOK_APPOINTMENT),
      _useMutation2 = slicedToArray(_useMutation, 1),
      bookAppointment = _useMutation2[0];

  var withLeadForm = !Boolean(props.prospect);

  var _useContext = React.useContext(TimezoneContext),
      timezone = _useContext.timezone;

  React.useEffect(function () {
    if (window && window.analytics) window.analytics.track("BookingPage Loaded");
  }, []);
  var parseUTCSlots = React.useCallback(function (slots) {
    var parsedSlots = {};
    Object.keys(slots).forEach(function (date) {
      slots[date].forEach(function (time) {
        var startAt = tz.tz("".concat(date, " ").concat(time.startAt, "+00:00"), timezone);
        var endAt = tz.tz("".concat(date, " ").concat(time.endAt, "+00:00"), timezone);
        var momentDate = startAt.format("YYYY-MM-DD");
        var currentAvailabilities = parsedSlots[momentDate] || [];
        parsedSlots[momentDate] = [].concat(toConsumableArray(currentAvailabilities), [{
          startAt: startAt.format("HH:mm:ss"),
          endAt: endAt.format("HH:mm:ss")
        }]);
      });
    });
    return parsedSlots;
  }, [timezone]);
  var result = reactHooks.useQuery(GET_CALENDAR, {
    variables: {
      campaignUid: props.campaign
    }
  });

  var query = _.get(result, "data.getCalendar", null);

  React.useEffect(function () {
    if (_.get(query, "facebookPixelId") && window && window.fbq) {
      window.fbq("init", query.facebookPixelId);
      window.fbq("track", "PageView");
    }
  }, [query]);

  var slots = _.get(query, "slots", "{}");

  if (typeof slots === "string") slots = JSON.parse(slots);
  var parsedSlots = parseUTCSlots(slots);

  var confirmAppointment =
  /*#__PURE__*/
  function () {
    var _ref = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee() {
      var time, appointmentObj, result, ok;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!confirmed) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setConfirmation(true);
              setLoading(true);
              time = tz.tz("".concat(appointment.date, " ").concat(appointment.time.startAt), timezone).format();
              appointmentObj = _objectSpread$4({}, appointment);
              _context.next = 8;
              return bookAppointment({
                variables: {
                  campaignUid: props.campaign,
                  prospect: appointmentObj.prospect,
                  timezone: appointmentObj.timezone,
                  time: time
                }
              });

            case 8:
              result = _context.sent;
              setLoading(false);
              ok = _.get(result, "data.bookAppointment.ok", false);

              if (ok) {
                if (window && window.analytics) {
                  window.analytics.track("AppointmentLead Captured");
                  window.analytics.track("Appointment Booked");
                }

                handleStep("CONFIRMED");
              } else {
                handleStep("FILL_LEAD_FORM");
                setError({
                  message: result.errorMessage
                });
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function confirmAppointment() {
      return _ref.apply(this, arguments);
    };
  }();

  if (!query || loading) {
    return React__default.createElement(Container$6, null, React__default.createElement(Loading, null));
  }

  if (currentStep === "SELECT_DATE") {
    return React__default.createElement(Container$6, null, React__default.createElement(SelectDate, {
      data: _objectSpread$4({}, query, {
        slots: parsedSlots
      }),
      appointment: appointment,
      setAppointment: setAppointment,
      handleStep: handleStep
    }));
  }

  if (currentStep === "SELECT_TIME") {
    return React__default.createElement(Container$6, null, React__default.createElement(SelectTime$1, {
      data: _objectSpread$4({}, query, {
        slots: parsedSlots
      }),
      appointment: appointment,
      setAppointment: setAppointment,
      handleStep: handleStep,
      confirmAppointment: confirmAppointment,
      withLeadForm: withLeadForm
    }));
  }

  if (currentStep === "FILL_LEAD_FORM") {
    return React__default.createElement(Container$6, null, React__default.createElement(LeadForm$1, {
      data: _objectSpread$4({}, query, {
        slots: parsedSlots
      }),
      appointment: appointment,
      setAppointment: setAppointment,
      handleStep: handleStep,
      confirmAppointment: confirmAppointment,
      error: error
    }));
  }

  return React__default.createElement(Container$6, null, React__default.createElement(Confirmation, {
    data: query,
    appointment: appointment
  }));
};

var BookByCampaign = styled.withTheme(Appointment);

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject3$8() {
  var data = taggedTemplateLiteral(["\n  mutation($prospectUid: String!, $timezone: String!, $time: String!) {\n    bookAppointmentByProspect(\n      prospectUid: $prospectUid\n      timezone: $timezone\n      time: $time\n    ) {\n      ok\n      errorMessage\n    }\n  }\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = taggedTemplateLiteral(["\n  query($prospectUid: String!) {\n    getCalendarByProspect(prospectUid: $prospectUid) {\n      title\n      fullName\n      description\n      slots\n      facebookPixelId\n    }\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n  max-height: 90vh;\n  min-height: 556px;\n  min-width: 264px;\n  width: 480px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border-radius: 10px;\n  background-color: #ffffff;\n  color: ", ";\n\n  @media (max-width: 554px) {\n    padding: 16px;\n    min-height: auto;\n    width: auto;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var Container$7 = styled__default.div(_templateObject$b(), function (props) {
  return props.theme.color.textBlack;
});
var GET_CALENDAR_BY_PROSPECT = gql(_templateObject2$9());
var BOOK_APPOINTMENT_BY_PROSPECT = gql(_templateObject3$8());

var Appointment$1 = function Appointment(props) {
  var _useState = React.useState({}),
      _useState2 = slicedToArray(_useState, 2),
      appointment = _useState2[0],
      setAppointment = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      confirmed = _useState6[0],
      setConfirmation = _useState6[1];

  var _useState7 = React.useState("SELECT_DATE"),
      _useState8 = slicedToArray(_useState7, 2),
      currentStep = _useState8[0],
      handleStep = _useState8[1];

  var _useState9 = React.useState(null),
      _useState10 = slicedToArray(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var _useMutation = reactHooks.useMutation(BOOK_APPOINTMENT_BY_PROSPECT),
      _useMutation2 = slicedToArray(_useMutation, 1),
      bookAppointmentByprospect = _useMutation2[0];

  var _useContext = React.useContext(TimezoneContext),
      timezone = _useContext.timezone;

  React.useEffect(function () {
    if (window && window.analytics) window.analytics.track("BookingPage Loaded");
  }, []);
  var parseUTCSlots = React.useCallback(function (slots) {
    var parsedSlots = {};
    Object.keys(slots).forEach(function (date) {
      slots[date].forEach(function (time) {
        var startAt = tz.tz("".concat(date, " ").concat(time.startAt, "+00:00"), timezone);
        var endAt = tz.tz("".concat(date, " ").concat(time.endAt, "+00:00"), timezone);
        var momentDate = startAt.format("YYYY-MM-DD");
        var currentAvailabilities = parsedSlots[momentDate] || [];
        parsedSlots[momentDate] = [].concat(toConsumableArray(currentAvailabilities), [{
          startAt: startAt.format("HH:mm:ss"),
          endAt: endAt.format("HH:mm:ss")
        }]);
      });
    });
    return parsedSlots;
  }, [timezone]);
  var result = reactHooks.useQuery(GET_CALENDAR_BY_PROSPECT, {
    variables: {
      prospectUid: props.prospect
    }
  });

  var query = _.get(result, "data.getCalendarByProspect", null);

  React.useEffect(function () {
    if (_.get(query, "facebookPixelId") && window && window.fbq) {
      window.fbq("init", query.facebookPixelId);
      window.fbq("track", "PageView");
    }
  }, [query]);

  var slots = _.get(query, "slots", "{}");

  if (typeof slots === "string") slots = JSON.parse(slots);
  var parsedSlots = parseUTCSlots(slots);

  var confirmAppointment =
  /*#__PURE__*/
  function () {
    var _ref = asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee() {
      var time, appointmentObj, result, ok;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!confirmed) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setConfirmation(true);
              setLoading(true);
              time = tz.tz("".concat(appointment.date, " ").concat(appointment.time.startAt), timezone).format();
              appointmentObj = _objectSpread$5({}, appointment);
              _context.next = 8;
              return bookAppointmentByprospect({
                variables: {
                  prospectUid: props.prospect,
                  timezone: appointmentObj.timezone,
                  time: time
                }
              });

            case 8:
              result = _context.sent;
              setLoading(false);
              ok = _.get(result, "data.bookAppointmentByProspect.ok", false);

              if (ok) {
                if (window && window.analytics) window.analytics.track("Appointment Booked");
                handleStep("CONFIRMED");
              } else {
                handleStep("SELECT_TIME");
                setError({
                  message: result.errorMessage
                });
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function confirmAppointment() {
      return _ref.apply(this, arguments);
    };
  }();

  if (!query || loading) {
    return React__default.createElement(Container$7, null, React__default.createElement(Loading, null));
  }

  if (currentStep === "SELECT_DATE") {
    return React__default.createElement(Container$7, null, React__default.createElement(SelectDate, {
      data: _objectSpread$5({}, query, {
        slots: parsedSlots
      }),
      appointment: appointment,
      setAppointment: setAppointment,
      handleStep: handleStep
    }));
  }

  if (currentStep === "SELECT_TIME") {
    return React__default.createElement(Container$7, null, React__default.createElement(SelectTime$1, {
      data: _objectSpread$5({}, query, {
        slots: parsedSlots
      }),
      appointment: appointment,
      setAppointment: setAppointment,
      handleStep: handleStep,
      confirmAppointment: confirmAppointment,
      error: error
    }));
  }

  return React__default.createElement(Container$7, null, React__default.createElement(Confirmation, {
    data: query,
    appointment: appointment
  }));
};

var BookByProspect = styled.withTheme(Appointment$1);
var theme = {
  color: {
    textBlack: "rgba(0, 0, 0, 0.7)",
    textDarkGray: "rgba(0, 0, 0, 0.6)",
    textGray: "rgba(0, 0, 0, 0.3)",
    textBlue: "#6c95bc",
    textRed: "#eb7878"
  },
  unit: {
    getRem: function getRem(px) {
      return "".concat(px / 16, "rem");
    }
  }
};

function _templateObject$c() {
  var data = taggedTemplateLiteral(["\n  .body {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    margin: 0;\n    padding: 0;\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalStyle = styled.createGlobalStyle(_templateObject$c());

var Booking = function Booking(_ref) {
  var _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? "development" : _ref$environment,
      props = objectWithoutProperties(_ref, ["environment"]);

  var _useState = React.useState(tz.tz.guess()),
      _useState2 = slicedToArray(_useState, 2),
      timezone = _useState2[0],
      setTimezone = _useState2[1];

  var graphqlClient = React.useMemo(function () {
    return client(config["".concat(environment, "GraphqlUri")]);
  }, [environment]);
  var isCampaign = Boolean(props.campaign);
  return React__default.createElement(TimezoneContext.Provider, {
    value: {
      timezone: timezone,
      setTimezone: setTimezone
    }
  }, React__default.createElement(reactHooks.ApolloProvider, {
    client: graphqlClient
  }, React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, React__default.createElement(React__default.Fragment, null, React__default.createElement(GlobalStyle, null), React__default.createElement("div", {
    className: "body"
  }, isCampaign ? React__default.createElement(BookByCampaign, props) : React__default.createElement(BookByProspect, props))))));
};

module.exports = Booking;